import * as React from 'react';
import { Popover } from '../../../Popover';
var EllipsisTooltip = function EllipsisTooltip(_ref) {
  var title = _ref.title,
    enabledEllipsis = _ref.enabledEllipsis,
    isEllipsis = _ref.isEllipsis,
    children = _ref.children;
  if (!title || !enabledEllipsis) {
    return children;
  }
  return React.createElement(Popover, {
    getPopper: function getPopper() {
      return title;
    },
    show: isEllipsis ? undefined : false
  }, children);
};
if (process.env.NODE_ENV !== 'production') {
  EllipsisTooltip.displayName = 'EllipsisTooltip';
}
export default EllipsisTooltip;